export default {
  data() {
    return {
      errorState: false,
      errors: null 
    }
  },

  methods: {
    setErrors(e) {
      this.errors = e
      this.setErrorsState(true)
    },

    resetErrors() {
      this.errors = null
      this.setErrorsState(false)
    },

    setErrorsState(state) {
      this.errorState = state
    },
  },
}
